import React, { useCallback, useEffect, useState } from "react";
import { getAllTeams } from "../utils/firebase.actions";
import { Team } from "../utils/types";
import useQuestions from "../hooks/useQuestions";
import TeamAnswers from "../components/TeamAnswers";
import TeamsSummary from "../components/TeamsSummary";
import QuestionsAnswers from "../components/QuestionsAnswers";

export default function Dashboard() {
  const [teams, setTeams] = useState<Team[]>([]);
  const [questions] = useQuestions();
  const loadTeams = useCallback(async () => {
    const teams = await getAllTeams();
    setTeams(teams);
  }, []);
  useEffect(() => {
    loadTeams();
  }, []);
  return (
    <section className="dashboard-container">
      <h2>Dashboard</h2>
      <TeamsSummary data={teams} />
      {!!teams.length && (
        <QuestionsAnswers
          updateTeams={loadTeams}
          questions={questions}
          teams={teams}
        />
      )}
      {/* <article className="teams-container">
        {teams.map((team) => (
          <TeamAnswers
            key={team.id}
            updateTeams={loadTeams}
            team={team}
            questions={questions}
          />
        ))}
      </article> */}
    </section>
  );
}
